import React from "react";
import { Link } from "react-router-dom";

export function AwardCard({ award }) {
  return (
    <div className="group relative bg-white rounded-xl shadow-lg overflow-hidden transform transition duration-300 hover:-translate-y-2 hover:shadow-2xl">
      <div className="relative h-64 overflow-hidden">
        <img
          src={award.imgUrl}
          className="w-full h-full object-cover transform transition duration-500 group-hover:scale-110"
          alt={award.title}
        />
      </div>
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-2xl font-bold text-orange-600 -mt-0">
            {award.title}
          </h3>
        </div>
        <p className="text-gray-600 mb-4 line-clamp-3">
          {award.description}
        </p>
        <div className="flex justify-between items-center">
          <Link
            to={`/awards/${award.awardId}`}
            className="inline-flex items-center text-orange-500 font-semibold group"
          >
            <span className="mr-2">Explore Award</span>
            <svg
              className="w-4 h-4 transform transition-transform duration-300 group-hover:translate-x-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M14 5l7 7m0 0l-7 7m7-7H3"
              ></path>
            </svg>
          </Link>
          <div className="flex space-x-2">
            <span className="w-2 h-2 bg-orange-500 rounded-full"></span>
            <span className="w-2 h-2 bg-orange-300 rounded-full"></span>
            <span className="w-2 h-2 bg-orange-200 rounded-full"></span>
          </div>
        </div>
      </div>
    </div>
  );
}
